import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Heading from "./components/headingComponent/Heading";
import Header from "./components/headerComponent/Header";
import FeedbackSection from "./components/feedbackSection/FeedbackSection";
import HeadingSlider from "./components/headingSliderComponent/HeadingSlider";
import VideoImg from "./components/videoPoster/VideoImg";
import Services from "./components/servicesSection/Services";
import Banner from "./components/bannerSection/Banner";
import Footer from "./components/footerSection/Footer";
import FeedbackSlider from "./components/feedbackSlider/FeedbackSlider";
import BelieveSlider from "./components/believeSection/BelieveSlider";
import ImageScroll from "./components/imageScrollSection/ImageScroll";
import BackToTop from "./components/backToTop/BackToTop";
import { BrowserRouter } from "react-router-dom";
import "./assets/scss/global.scss";
import MediaGrid from "./components/MediaGrid/MediaGrid";
import ScrollingLogos from "./components/ScrollingLogos/ScrollingLogos";
import CarouselComponent from "./components/TestimonialSection/CarouselComponent ";
import { Card } from "antd";
import CardSlider from "./components/TestimonialSection/CardSlider";
import TermsandCondition from "./components/terms&ConditionComponent/TermsandCondition";
function App() {
  return (
    <BrowserRouter>
      {/* <section id="sliderSection"> */}
        <Header />
        <Heading />
        {/* <MarqueSlide /> */}
        {/* <HeadingSlider /> */}
      {/* </section> */}
      {/* <FeedbackSection /> */}
      <VideoImg />
      <Services />
      {/* <MediaGrid /> */}
      {/* <section id="bannerSlider-section"> */}
        <ImageScroll />
      {/* </section> */}
      <Banner />
      {/* <FeedbackSlider /> */}
      {/* <BelieveSlider /> */}
      {/* <CarouselComponent /> */}
      <CardSlider />
      <ScrollingLogos />
      <Footer />
      <BackToTop />
    </BrowserRouter>
  );
}

export default App;
